<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="endpoints-overview-wrapper">
  <app-device-overview
    [selectedOrgId]="selectedOrgId$ | async">
  </app-device-overview>
</div>